import React from "react";

import "./ItemsCount.scss";

export const ItemsCount = ({ count }) => {
  return <span className="ItemsCount">Кол-во действий: {count}</span>;
};
